// extracted by mini-css-extract-plugin
module.exports = {"of-image":"ImageWithSets_of-image__ovnCW","of-image__picture":"ImageWithSets_of-image__picture__4hzsN","of-image__img":"ImageWithSets_of-image__img__pezo7"};